<template>
  <app-window :value="dialogProps">
    <template v-slot:body>
      <perfil
        :usuario="usuario"
        :perfil-proprio="false"
      />
    </template>
  </app-window>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import Perfil from '@/components/perfil/Perfil';
import AppWindow from '@/components/core/AppWindow';

const usuarioRepository = RepositoryFactory.get('usuario');

export default {
  name: 'DialogPerfil',

  components: { Perfil, AppWindow },

  props: {
    dialogProps: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      usuario: {
        perfil: {},
        unidade: {
          unidadePai: {},
        },
      },
    };
  },

  watch: {
    'dialogProps.load': function (nv) {
      if (nv) {
        usuarioRepository.getByPerfilId(this.dialogProps.perfilId).then((res) => {
          this.usuario = res.data;
          this.dialogProps.visibilidade = true;
          this.dialogProps.load = false;
        });
      }
    },
  },
};
</script>
